import "./sideMenu.scss";
import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

import cancelIcon from "../../assets/icons/cancel.svg";

const SideMenu = ({ showSideMenu, setShowSideMenu }) => {
  useEffect(() => {
    // console.log(window.screen.width);
    if (window.screen.width < 1535) {
      setShowSideMenu(false);
    }
  }, [window.screen.width]);

  // handlers
  const scrollToFooter = () => {
    const footerSection = document.getElementById("footer-sec");
    if (footerSection) {
      footerSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="menu">
      <svg
        onClick={() => setShowSideMenu(!showSideMenu)}
        className="menu-icon z-30  items-center cursor-pointer m-2 mr-0 ml-4 xm:w-[20px] xlg:w-[40px] right-3"
        fill="#d2ae6d"
        viewBox="0 0 100 80"
        width="28"
        height="28"
      >
        <rect width="100" height="13"></rect>
        <rect y="30" width="100" height="12"></rect>
        <rect y="60" width="100" height="13"></rect>
        {/* <img className="menu-icon" src={menuIcon} alt="icon" /> */}
      </svg>

      <div
        className={`shadow top-0 left-0 w-[12rem] h-screen bg-[#02204D] text-red fixed z-40 ${
          showSideMenu
            ? "transition duration-1000 ease-in-out translate-x-0 "
            : "transition duration-1000 ease-in-out translate-x-[-100%]"
        }`}
      >
        <button
          className={`flex text-3xl items-center cursor-pointer z-50
            sm:top-1 ${
              showSideMenu
                ? "transition duration-1000 ease-in-out -translate-x-[90%] fixed "
                : "transition duration-1000 ease-in-out translate-x-0 fixed "
            }`}
          onClick={() => setShowSideMenu(!showSideMenu)}
        >
          <img
            className=" w-5 h-5 my-3    
            "
            width={16}
            height={16}
            src={cancelIcon}
            alt="cancelIcon"
          />
        </button>
        <ul
          className="flex flex-col justify-evenly items-end px-10 text-[16px] text-black  duration-700 font-bold h-[600px]
        md:text-[15px]
        sm:text-[12px] sm:py-3 
        screen345:text-[11px]
        xlg:text-[22px]

        "
        >
          <NavLink
            onClick={() => setShowSideMenu(!showSideMenu)}
            className={({ isActive }) => (isActive ? "text-[#d2ae6d] " : "text-[#fff]")}
            to="/"
          >
            <li className="">صفحه اصلی</li>
          </NavLink>
          <NavLink
            onClick={() => setShowSideMenu(!showSideMenu)}
            className={({ isActive }) => (isActive ? "text-[#d2ae6d] " : "text-[#fff]")}
            to="/all-prices"
          >
            <li className="">نرخ ها</li>
          </NavLink>
          <NavLink
            onClick={() => {
              setShowSideMenu(!showSideMenu);
              scrollToFooter();
            }}
            className={({ isActive }) => (isActive ? "text-[#d2ae6d] " : "text-[#fff]")}
            to="/about-us"
          >
            <li className="">درباره ما</li>
          </NavLink>
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
